import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModulosComponent } from './modulos.component';
import { routing } from './modulos.routing';
import { ModulosService } from './modulos.service';
import { UsuarioService } from '../usuario/usuario.service';
import { ListaModulosService } from '@elotech/angular-common';
import { SearchBoxComponent } from './component/areabox/search-box.component';
import { AreaBoxComponent } from './component/areabox/area-box-list.component';

@NgModule({
  imports: [CommonModule, routing],
  declarations: [ModulosComponent, AreaBoxComponent, SearchBoxComponent],
  providers: [ModulosService, UsuarioService, ListaModulosService],
  exports: [AreaBoxComponent, SearchBoxComponent]
})
export class ModulosModule {}
